import { useState, useEffect } from "react";

const useResponsiveFont = (base: number) => {
  const [size, setSize] = useState(base);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 1440) {
        setSize(base * 0.7);
      } else {
        setSize(base);
      }
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [base]);

  return size;
};

export default useResponsiveFont;
